{
  "confirmationNumber": "Numer potwierdzenia {number}",
  "dateTimeRange": "{date} od {startTime} do {endTime}"
}
